<!-- 空数据状态的插槽 -->
<template>
    <div >
        <div class="flex_center ">
            <div style="text-align: center;margin-top: 3%;">
                    <img style="width: 386px;height: 208px;" src="../../assets//images/seachCompany_noData.png" alt="">
            <div class="text-title">Your search -"{{ $route.query.searchname }}" . did not match any companies</div>
            </div>
        </div>
    <div class="henggang"></div>
        <!-- <h3 class="text-title">Your search - ""{{ $route.query.searchname }}"" - did not match any companies</h3> -->
     <div class="no_date_box">
           <div class="no_date_box_left">
              <h2 class="title">Suggestions:

             </h2>
             <el-button @click="report()" >Order Report</el-button>
           </div>
        <ul>
            <li class="ul-title" v-for="(item, index) in lilist" :key="index">{{ item }}</li>
        </ul>
 
        
        <ul>
        </ul>
     </div>
    </div>
</template>
<script>
import { mixins1 } from '@/mixins/index';
export default {
    mixins: [mixins1],
    data() {
        return {
            tabCountryList: [],
          
            lilist: ['Make sure all words are spelled correctly.', 'Try different keywords.', "Try to use company's native names.", 'Try to exclude company types (e.g. Corp, SARL, Inc., Limited, LLC, etc.)', 'You can submit your search name to CSI for manual investigation directly.'],
        };
    },
    created() {
   
            
    },
 
    methods: {
        report() {
            this.$parent.$parent.showReportIndex = true;
        },
 
    },
};
</script>
<style scoped>
.no_date_box {
    text-align: left;
    display: flex;
    justify-content: center;
}
.no_img {
    width: 250px;
    height: 197px;
    margin: 0 auto;
    margin-bottom: 4px;
}
.no_img img {
    width: 100%;
    height: auto;
}
.des_one {
    line-height: 32px;
 
    font-family: 'Arial Bold';
    color: #1290c9;
    margin-bottom: 10px;
}
.des_two {

    color: #022955;
    line-height: 24px;
}
.el-button {
    background: #1290c9 !important;
    color: white;
    /* padding: 15px 30px; */
    font-size: 16px;
    height: 40px;
    width: 140px;
    border-radius: 10px;
}
.el-table__empty-block {
    text-align: left !important;
}
.text-title {
    color: #022955;
    /* height: 1.285714285714286rem ; */
  
}
.title {
    font-size: 32px;
    font-size: 32px;
color: #1A2332;
  
    margin-bottom:40px;
   
}
 
.ul-title {
    color: #022955;
    height: 38px;
    line-height: 38px;
    list-style: disc;
  
 
}
ul li::marker {
    color: #1290c9;
}
.henggang{
    height: 1px;
background: #D8D8D8;
margin-top: 2%;
margin-bottom:2%;
}
.no_date_box_left{
    margin-right: 6%;
    text-align: left;
}

</style>